import { corporateMembersFormData } from "../data/CorporateMembersForm.data";

export const setAllDropDownFieldForCorporateDashboard = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        // "Membership Type": filterDropDownList("membershipType"),
        // "Corporate Status": filterDropDownList("status"),
        "FilterByMembershipType": filterDropDownList("Membership Type"),
        "FilterByStatus": [
            { value: 0, label: "Not Applicable" },
            ...filterDropDownList("Corporate Status")
        ],
        "organisationCategoryId":filterDropDownList("Org Category")
    };

    const formFields = [...corporateMembersFormData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};